import React from "react";
import { cn } from "@/lib/utils";

interface ToggleChipGroupProps {
  options: { value: string; label: string }[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

/**
 * A multi-select rendered as toggleable chips — used for the catalog's
 * closed vocabularies (audiences, trades, stages).
 */
export default function ToggleChipGroup({
  options,
  selected,
  onChange,
}: ToggleChipGroupProps) {
  const toggle = (value: string) => {
    onChange(
      selected.includes(value)
        ? selected.filter((item) => item !== value)
        : [...selected, value],
    );
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const isSelected = selected.includes(option.value);
        return (
          <button
            className={cn(
              "rounded-full border px-3 py-1 text-sm transition-colors",
              isSelected
                ? "border-transparent bg-gray-900 text-white dark:bg-white dark:text-gray-900"
                : "border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white",
            )}
            key={option.value}
            onClick={() => toggle(option.value)}
            type="button"
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
